import { render, staticRenderFns } from "./dragpicturew.vue?vue&type=template&id=36badf0a&scoped=true"
import script from "./dragpicturew.vue?vue&type=script&lang=js"
export * from "./dragpicturew.vue?vue&type=script&lang=js"
import style0 from "./dragpicturew.vue?vue&type=style&index=0&id=36badf0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36badf0a",
  null
  
)

export default component.exports